/**
 * Values for Maximum dry density field TestFractionParticleDensity.ParticleDensityDeterminationMethod
 */
export enum ParticleDensityDeterminationMethod {
  Assumed = 'Assumed',

  Measured = 'Measured',

  CalculatedFromCurve = 'CalculatedFromCurve',
}

/**
 * Values for BS Preparation field Preparation.AggregationsBrokenDownBy
 */
export enum AggregationsBrokenDownByMethod {
  None = 'None',
  Chopping = 'Chopping',
  Shredding = 'Shredding',
}

/**
 * Values BS Preparation field Preparation.MouldType
 */
export enum MouldSize {
  OneLitre = 'onelitre',
  CBR = 'cbr',
}

/**
 * Values BS Preparation field Preparation.SampleDriedBy
 */
export enum SampleDriedByMethod {
  None = 'None',
  Air = 'Air',
  Oven = 'Oven',
}

/**
 * Values BS Preparation field Preparation.BrokenDownToPassSieveSize
 */
export enum BrokenDownToPassSieveSizeOption {
  Sieve5mm = 'Sieve5mm',
  Sieve20mm = 'Sieve20mm',
}

export enum VisualNominalParticleSizeType {
  Sieve0_063mm = '0_063',
  Sieve2_00mm = '2_00',
  Sieve10_0mm = '10_0',
  Sieve31_5mm = '31_5',
  Sieve63_0mm = '63_0',
}

export enum GradningZoneType {
  One = '1',
  Two = '2',
  Three = '3',
  Four = '4',
  Five = '5',
  X = 'X',
}
